export const routes = (parentName) => {
  return [
    {
      path: 'operators',
      component: () => import('./Index.vue'),
      children: [
        {
          path: '',
          name: `${parentName}-Operators`,
          component: () => import('./List.vue'),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: 'new',
          name: `${parentName}-Operators-New`,
          component: () => import('./Upsert.vue'),
        },
        {
          path: ':id',
          name: parentName + '-' + 'Operators-View',
          component: () => import('./View.vue'),
        },
        {
          path: ':id/edit',
          name: parentName + '-' + 'Operators-Edit',
          component: () => import('./Upsert.vue'),
        },
      ],
    },
  ];
};
